
import jsbarcode from "jsbarcode";
import qrcode from "qrcode";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";
import React from "react";
import { Layout_placeLines, Layout_codeValueFontSizePt, Layout_layout } from "../Shared/Label.js";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { mapIndexed, singleton as singleton_1, append as append_1, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, empty, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";

export function codeImage(codeType, code) {
    if (code.trim() === "") {
        return undefined;
    }
    else {
        const url = (codeType.tag === 1) ? ((function(lib, text){ var c = document.createElement('canvas'); c.width = 800; c.height = 240; try { lib(c, text, { format: 'CODE128', width: 3, height: 200, displayValue: false, margin: 30 }); return c.toDataURL('image/png'); } catch(e) { return null; } })(jsbarcode, code)) : ((function(lib, text){ try { var qr = lib.create(text, { errorCorrectionLevel: 'M' }); var n = qr.modules.size; var data = Array.from(qr.modules.data); var s = 12; var q = 4; var total = (n + 2 * q) * s; var c = document.createElement('canvas'); c.width = total; c.height = total; var ctx = c.getContext('2d'); ctx.imageSmoothingEnabled = false; ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, total, total); ctx.fillStyle = '#000'; for (var i = 0; i < n; i++) { for (var j = 0; j < n; j++) { if (data[i * n + j]) { ctx.fillRect((j + q) * s, (i + q) * s, s, s); } } } return c.toDataURL('image/png'); } catch(e) { return null; } })(qrcode, code));
        if (Operators_IsNull(url) ? true : (url === "")) {
            return undefined;
        }
        else {
            return url;
        }
    }
}

export const pixelsPerMm = 96 / 25.4;

function px(zoom, mm) {
    return (mm * pixelsPerMm) * zoom;
}

function ptToPx(zoom, pt) {
    return ((pt * 96) / 72) * zoom;
}

export function LabelPreview(props) {
    let elems_1;
    const layout = Layout_layout(props.Configuration);
    const zoom = props.Zoom;
    const codeType = props.Configuration.CodeType;
    let image;
    const dependencies_1 = [codeType, props.Code];
    image = reactApi.useMemo(() => codeImage(codeType, props.Code), dependencies_1);
    const boxStyle = (labelBox) => ofArray([["position", "absolute"], ["left", px(zoom, labelBox.X) + "px"], ["top", px(zoom, labelBox.Y) + "px"], ["width", px(zoom, labelBox.Width) + "px"], ["height", px(zoom, labelBox.Height) + "px"]]);
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", ["relative", "bg-white", "shadow-md", "border", "border-[#B6BECB]", "overflow-hidden", "shrink-0"])], ["style", {
        width: px(zoom, props.Configuration.WidthMm) + "px",
        height: px(zoom, props.Configuration.HeightMm) + "px",
    }], (elems_1 = toList(delay(() => {
        let matchValue, codeBox_1, codeBox, url;
        return append((matchValue = layout.CodeBox, (matchValue == null) ? (empty()) : ((image == null) ? ((codeBox_1 = matchValue, singleton(reactElement("div", {
            style: createObj(boxStyle(codeBox_1)),
            className: join(" ", ["bg-background"]),
        })))) : ((codeBox = matchValue, (url = image, singleton(reactElement("img", {
            "data-test-id": concat(props.TestId, ..."-code"),
            src: url,
            alt: props.Code,
            style: createObj(append_1(boxStyle(codeBox), singleton_1(["objectFit", "fill"]))),
        }))))))), delay(() => {
            let matchValue_2, valueBox;
            return append((matchValue_2 = layout.CodeValueBox, (matchValue_2 == null) ? (empty()) : ((valueBox = matchValue_2, singleton(reactElement("div", {
                "data-test-id": concat(props.TestId, ..."-code-value"),
                style: createObj(append_1(boxStyle(valueBox), ofArray([["fontSize", ptToPx(zoom, Layout_codeValueFontSizePt(valueBox)) + "px"], ["lineHeight", px(zoom, valueBox.Height) + "px"], ["textAlign", "center"], ["whiteSpace", "nowrap"], ["overflow", "hidden"], ["fontFamily", "Ubuntu, Helvetica, Arial, sans-serif"]]))),
                children: props.Code,
            }))))), delay(() => {
                let matchValue_3, matchValue_4, logoBox, logoUrl;
                return append((matchValue_3 = layout.LogoBox, (matchValue_4 = props.LogoUrl, (matchValue_3 != null) ? ((matchValue_4 != null) ? ((logoBox = matchValue_3, (logoUrl = matchValue_4, singleton(reactElement("img", {
                    src: logoUrl,
                    alt: "",
                    style: createObj(append_1(boxStyle(logoBox), ofArray([["objectFit", "contain"], ["objectPosition", "right top"]]))),
                }))))) : (empty())) : (empty()))), delay(() => {
                    let elems;
                    const matchValue_6 = layout.TextBox;
                    if (matchValue_6 == null) {
                        return empty();
                    }
                    else {
                        const textBox = matchValue_6;
                        const placedLines = Layout_placeLines((fontSizePt, bold, text) => ((function(pt, bold, text){ var c = document.createElement('canvas'); var ctx = c.getContext('2d'); ctx.font = (bold ? 'bold ' : '') + (pt * 96 / 72) + 'px Ubuntu, Helvetica, Arial, sans-serif'; return ctx.measureText(text).width * 25.4 / 96; })(fontSizePt, bold, text)), textBox, props.Lines);
                        return singleton(reactElement("div", createObj(ofArray([["data-test-id", concat(props.TestId, ..."-text")], ["style", createObj(append_1(boxStyle(textBox), singleton_1(["overflow", "hidden"])))], (elems = toList(delay(() => mapIndexed((index, placed) => reactElement("div", {
                            key: index,
                            "data-test-id": `${props.TestId}-line-${index}`,
                            style: {
                                position: "absolute",
                                left: 0,
                                top: px(zoom, placed.Y - textBox.Y) + "px",
                                width: 100 + "%",
                                height: px(zoom, placed.Height) + "px",
                                lineHeight: px(zoom, placed.Height) + "px",
                                fontSize: ptToPx(zoom, placed.FontSizePt) + "px",
                                fontWeight: placed.Line.Bold ? 700 : 400,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontFamily: "Ubuntu, Helvetica, Arial, sans-serif",
                                color: "#000",
                            },
                            children: placed.Line.Content,
                        }), placedLines))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
                    }
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

